module.exports = __webpack_public_path__ + "static/media/chat-bubble-user.df0a432f.svg";